import { Injectable } from '@angular/core';

import { FirebazeStorageService } from '../lib/firebazeStorage.service';
import { UtilsService } from '../lib/utils.service';
import type { TRandomWords } from '@shared/models';

@Injectable({
    'providedIn': 'root'
})
export class PasswordService {
    private numbers: string[] = [];
    private colors: string[] = [];
    private adjectives: string[] = [];
    private nouns: string[] = [];

    constructor(private firebazeStorageService: FirebazeStorageService, private utilsService: UtilsService) {
    }

    public async generate(): Promise<string> {
        await this.loadRandomWordDocument();

        // Originally, shuffleWords() was being called only once.
        // However, I noticed that the words 'Thirteen' and 'Black' were almost always being selected.
        // So, I decided that more shuffles were needed.
        for (let idx = 0; idx < 2; idx++) {
            this.shuffleWords();
        }

        const number = this.numbers[0];
        const color = this.colors[0];
        // const adjective = this.adjectives[0];
        const noun = this.nouns[0];

        // const password = `${number}${color}${adjective}${noun}`;
        const password = `${number}${color}${noun}`;
        return password;
    }

    private shuffleWords(): void {
        this.numbers = this.utilsService.shuffle(this.numbers);
        this.colors = this.utilsService.shuffle(this.colors);
        this.adjectives = this.utilsService.shuffle(this.adjectives);
        this.nouns = this.utilsService.shuffle(this.nouns);
    }

    private async loadRandomWordDocument(): Promise<void> {
        // Prevent the loading of the document twice.
        if (this.numbers.length > 0 && this.colors.length > 0 &&
            this.adjectives.length > 0 && this.nouns.length > 0) {
            return;
        }

        const randomWords: TRandomWords = await this.firebazeStorageService.getRandomWordDocument();
        this.numbers = randomWords.numbers;
        this.colors = randomWords.colors;
        this.adjectives = randomWords.adjectives;
        this.nouns = randomWords.nouns;
    }
}
